<template>
    <common-page flex-column card-content>
        <query-view ref="queryView"
                    enable-edit
                    :config-code="$_configCode"
                    :default-filter-form="defaultFilterForm"
                    :filter="scanFilter">
            <template #leftHeader>
                <mini-button :disable="$_notChecked" @btnClick="unpackingVisible = true">
                    <i class="fa fa-fw fa-clipboard-check"></i>
                    <span>手动检验</span>
                </mini-button>
                <mini-button @btnClick="goToScanCheck">
                    <i class="fa fa-fw fa-qrcode"></i>
                    <span>扫码检验</span>
                </mini-button>
                <mini-button @btnClick="openMatScanner">
                    <i class="fa fa-fw fa-box"></i>
                    <span>扫描箱码</span>
                </mini-button>
                <mini-button @btnClick="goToSign">
                    <i class="fa fa-fw fa-signature"></i>
                    <span>手写签字</span>
                </mini-button>
            </template>
        </query-view>

        <template #outer>
            <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="matScannerVisible" append-to-body
                       title="扫一扫" @close="closeMatScannerDialog">
                <qr-code-scanner ref="matScanner" @getCodeData='getPackageInfo'>
                </qr-code-scanner>
            </el-dialog>

            <el-dialog :close-on-click-modal='false' :visible.sync="unpackingVisible" append-to-body title="手动检验"
                       width="55%"
                       @close='clearUnpacking'>
                <el-form ref="unpackingForm" :model="unpackingForm" :rules="unpackingRule" label-width="auto">
                    <el-form-item label="账实是否相符" prop="accountMatchActualSituationOrNot">
                        <el-radio-group v-model="unpackingForm.accountMatchActualSituationOrNot">
                            <el-radio :label=true>是</el-radio>
                            <el-radio :label=false>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="账实不符原因" prop="notMatchReason">
                        <el-input v-model="unpackingForm.notMatchReason" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="unpackingVisible = false">取消</el-button>
                    <el-button type="primary" @click="manualCheck()">确认</el-button>
                </div>
            </el-dialog>
        </template>
    </common-page>
</template>
<script>
// Author Lin
// Date 2021-06-28 10:31:33

import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";

export default {
    name: "sithMesInventoryUnpackingListView",
    components: {CommonPage, QueryView, MiniButton, qrCodeScanner},
    mixins: [miniTableCheckedMixin, emCommonApiMixin],
    data() {
        return {
            // BIND(1, "绑定"), UNBIND(0, "已解绑"): 仅初始化搜索框，用户可在 UI 上改为 0 后重新搜索
            // select 字段在筛选区使用 In 运算符（select-multi），值须为逗号分隔字符串而非数组
            defaultFilterForm: {
                bindingStateIn: "1",
            },
            // 扫描箱码后按 packageId 过滤（packageId 已作为查询列，无需拼接实体名）
            scanFilter: {
                packageId: null,
            },
            matScannerVisible: false,
            unpackingVisible: false,
            unpackingForm: {
                accountMatchActualSituationOrNot: true,
                notMatchReason: ''
            },
            unpackingRule: {
                accountMatchActualSituationOrNot: [{required: true, message: '请选择是否相符.'}]
            },
        }
    },
    computed: {
        $_configCode() {
            return 'unpackingMaterial';
        },
    },
    methods: {
        refreshTable() {
            if (this.$refs.queryView) {
                this.$refs.queryView.queryRows();
                this.$refs.queryView.countRows();
            }
        },

        getPackageInfo(data) {
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var packageId = obj['packageId'];
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            this.matScannerVisible = false;
            this.scanFilter.packageId = packageId;
            this.refreshTable();
        },

        goToScanCheck() {
            this.$router.push({name: 'sithMesInventoryUnpackingScanCheck'});
        },

        goToSign() {
            this.$router.push({name: 'sithMesInventoryUnpackingSign'});
        },

        openMatScanner() {
            this.matScannerVisible = true;
            setTimeout(() => {
                this.$refs.matScanner.openCamera('');
            }, 500);
        },
        closeMatScannerDialog() {
            this.$refs.matScanner.closeCamera();
            this.$refs.matScanner.resetOutputData();
            this.matScannerVisible = false;
        },

        clearUnpacking() {
            this.unpackingForm.accountMatchActualSituationOrNot = '';
            this.unpackingForm.notMatchReason = ''
        },

        manualCheck() {
            let self = this;
            self.$refs["unpackingForm"].validate(valid => {
                if (valid) {
                    if (!self.unpackingForm.accountMatchActualSituationOrNot && self.unpackingForm.notMatchReason === '') {
                        self.$message({
                            message: "账实不符，请填写原因！",
                            type: "error",
                        });
                        return;
                    }

                    let url = `${this.$_emApiMixin_entityBaseApi(
                            "sithMesInventoryPackageMaterial")}/manualCheck?ids=${this.selectIds}&accountMatchActualSituationOrNot=${self.unpackingForm.accountMatchActualSituationOrNot}&notMatchReason=${self.unpackingForm.notMatchReason}`
                    self.$_emApiMixin_post(url, {})
                            .then(response => {
                                if (response.status === 200) {
                                    self.$message({
                                        message: "检验完成！",
                                        type: "success",
                                    });

                                    self.refreshTable();
                                } else {
                                    self.$message({
                                        message: "检验失败！",
                                        type: "error",
                                    });
                                }
                            })
                            .finally(() => this.unpackingVisible = false)
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                }
            })
        },
    }
};
</script>
